import { reducerTypes } from './types';
import { IPageInfo } from '../../interfaces/common';
import { IOffer } from '../../interfaces/offer';

export const getOffersAction = (data: IOffer[]) => ({
  type: reducerTypes.GET_ALL_OFFERS,
  payload: data,
});

export const getMoreOffersAction = (data: IOffer[]) => ({
  type: reducerTypes.GET_MORE_OFFERS,
  payload: data,
});

export const getOfferAction = (data: IOffer) => ({
  type: reducerTypes.GET_OFFER,
  payload: data,
});

export const setSizePageAction = (page: IPageInfo) => ({
  type: reducerTypes.SET_PAGE_INFO,
  payload: page,
});
